module.exports = __webpack_public_path__ + "ffdea895a98e51fe20f033cfbf10e44c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/oscar-outline.svg
// module id = 27
// module chunks = 0